export enum profileTypes {
    Prostitute = 1,
    Masseuse = 2,
    BDSM = 3,
}